/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import QueuePostDetailComponent from 'app/components/Queue/QueuePostDetailComponent.jsx';
import QueueSectionComponent from 'app/components/Queue/QueueSectionComponent.jsx';
import * as _ from 'underscore';
import PostListUtilities from 'app/modules/PostListUtilities.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import InfiniteScroll from 'react-infinite-scroller';

class QueueDetailComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            queue: null,
            emptyState: false
        };

        this.moveToTop = this.moveToTop.bind(this);
        this.prepareQueueForView = this.prepareQueueForView.bind(this);
        this.dragEnd = this.dragEnd.bind(this);
        this.dragStart = this.dragStart.bind(this);
        this.dragOver = this.dragOver.bind(this);
        this.dragLeave = this.dragLeave.bind(this);

    }


    moveToTop(e) {

        let itemId = parseInt(e.currentTarget.dataset.itemid, 10);

        this.props.moveToTopMethod(itemId);

    }

    prepareQueueForView() {
        let items = [...this.props.queueList],
            referenceDate = items.length ? moment.tz(new Date(items[0].queuetime), this.props.user.detail.timezone) : null,
            itemTimeStamp = referenceDate,
            ret = [];

        if (this.props.category !== null) {
            if (this.props.category !== -1) {
                items = _.filter(this.props.queueList, function(item){
                    return (parseInt(item.tagID, 10) === parseInt(this.props.category, 10));
                }.bind(this));
            }
            if (items.length === 0) {
                return ret;
            }
        }

        for (let i = 0; i < items.length; i++) {
            itemTimeStamp = moment.tz(new Date(items[i].queuetime), this.props.user.detail.timezone);
            if (referenceDate.isBefore(itemTimeStamp, 'day') || ret.length === 0) {
                ret.push({itemTimeStamp: itemTimeStamp.unix()});
                referenceDate = itemTimeStamp;
            }
            items[i].itemTimeStamp = itemTimeStamp.unix();
            ret.push(items[i]);
        }

        return ret;

    }

    dragStart(e) {

        e.dataTransfer.setData('text/plain', e.target.id);

    }

    dragEnd(e) {
        let id = e.dataTransfer.getData('text/plain'),
            item = null,
            target = parseInt(e.currentTarget.id, 10),
            items = this.props.queueList;

        e.preventDefault();

        if (id === target) {
            return;
        }

        for (let i = 0; i < items.length; ++i) {
            if (parseInt(items[i].id, 10) === parseInt(id, 10)) {
                item = items.splice(i, 1);
                break;
            }
        }

        if (item) {
            if (parseInt(items[0].id, 10) === target) {
                items.unshift(item[0]);
            } else if (parseInt(items[items.length - 1].id, 10) === target) {
                items.push(item[0]);
            } else {
                for (let i = 0; i < items.length; ++i) {
                    if (parseInt(target) === parseInt(items[i].id)) {
                        items.splice(i, 0, item[0]);
                        break;
                    }
                }
            }
        }

        this.props.sortMethod(items);

    }

    dragOver(e) {


        e.dataTransfer.effectAllowed = "move";
        if (e.currentTarget.id !== undefined) {
            e.currentTarget.classList.add('drag-over');
        }
        e.preventDefault();

    }

    dragLeave(e) {

        e.currentTarget.classList.remove('drag-over');
        e.preventDefault();

    }

    render() {

        let items = this.prepareQueueForView(),
            spinner = (
                <div key={0} className="waiting-block">
                    <i className="fa fa-spinner fa-pulse"></i>
                </div>
            );

        if (items.length === 0 && this.props.category) {
            return (
                <EmptyState message="There are no items queued for this category"/>
            );
        }

        return (
            <div style={{height: '1000px', overflow: 'auto'}}>
                <InfiniteScroll
                    className="infinite-scroller queue-item"
                    threshold={300}
                    loadMore={this.props.scrollHandler}
                    loader={spinner}
                    hasMore={this.props.hasMoreItems}
                    useWindow={false}
                    initialLoad={false}>
                    {items.map(function(item, i) {
                        let postType,
                            input,
                            itemKey = 0,
                            handles = '';

                        if (typeof item === 'object') {
                            if (item.hasOwnProperty('preview')) {
                                postType = PostListUtilities.getPostType(item, this.props);

                                input = this.props.inputs.filter(function(input) {
                                    return input.id === item.iID;
                                });

                                input = typeof input === 'object'
                                    ? input[0]
                                    : input;

                                if (item.id === "-1") {
                                    itemKey = "item-pool-" + i;
                                } else {
                                    itemKey = item.id;
                                    handles = ".drag-handle, .drag-handle *"
                                }

                                return (
                                    <QueuePostDetailComponent
                                        {...this.props}
                                        handle={handles}
                                        index={i}
                                        input={input}
                                        item={item}
                                        key={itemKey}
                                        sortKey={i}
                                        sort={this.props.sortMethod}
                                        dragEnd={this.dragEnd}
                                        dragStart={this.dragStart}
                                        dragOver={this.dragOver}
                                        dragLeave={this.dragLeave}
                                        moveToTop={this.moveToTop}
                                        post={item}
                                        postModalMethod={this.props.postModalMethod}
                                        postType={postType}
                                        removeMethod={this.props.removeMethod}
                                        rescheduleMethod={this.props.rescheduleMethod}
                                        categoryList={this.props.categoryList}
                                        category={this.props.category}/>
                                );
                            } else {
                                return (
                                    <QueueSectionComponent
                                        {...this.props}
                                        time={item.itemTimeStamp}
                                        key={"section-" + item.itemTimeStamp}
                                        index={i}/>
                                );
                            }
                        } else {
                            return null;
                        }
                }, this)}
                </InfiniteScroll>
            </div>
        );

    }

};

QueueDetailComponent.displayName = "QueueDetailComponent";

QueueDetailComponent.propTypes = {
    inputs: PropTypes.array,
    postModalMethod: PropTypes.func,
    queueList: PropTypes.array,
    removeMethod: PropTypes.func,
    rescheduleMethod: PropTypes.func,
    user: PropTypes.object
};

QueueDetailComponent.defaultProps = {
    inputs: [],
    postModalMethod: null,
    queueList: [],
    removeMethod: null,
    rescheduleMethod: null,
};

export default QueueDetailComponent;
